export const getProgressBarStepClass = (currentPos, currentStep) => {
    if (currentPos < currentStep) {
        return 'complete';
    }
    if (currentPos === currentStep) {
        return 'active';
    }
    return 'incomplete';
};
